module.exports = __webpack_public_path__ + "img/menu-manager.c5c59585.svg";